import { render, staticRenderFns } from "./BuyGroupList.vue?vue&type=template&id=708f82c1"
import script from "./BuyGroupList.vue?vue&type=script&lang=js"
export * from "./BuyGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports